import { connect } from 'react-redux';
import ProfilePage from './component';
import { getAnswers, getProfilePhoto } from '../../actions';

export const mapStateToProps = (state) => {
  const user = state.feed.selectedEmail === null ? state.user : state.feed.users[state.feed.selectedEmail];
  return {
    surveyQuestions: state.user.answers,
    surveyAnswers: user?.answers,
    showOther: state.feed.selectedEmail !== null,
    surveySrc: state.survey.src,
    surveyComplete: state.survey.done,
    userType: state.user.userType,
    name: user?.name,
    email: state.feed.selectedEmail === null ? user.email : state.feed.selectedEmail,
  };
};

export default connect(mapStateToProps, { getAnswers, getProfilePhoto })(ProfilePage);
